// ThemeSelector.js — 3 thèmes couleur uniquement

import React, { useState, useEffect, useRef } from 'react';

export const THEMES = {
  dark: {
    id: 'dark', label: 'Nuit', icon: '🌑',
    vars: {
      '--bg':           '#050810',
      '--surface':      'rgba(8, 14, 30, 0.92)',
      '--surface-2':    'rgba(15, 22, 45, 0.95)',
      '--border':       'rgba(80, 130, 220, 0.18)',
      '--border-bright':'rgba(80, 130, 220, 0.45)',
      '--text-primary': '#e8edf8',
      '--text-secondary':'rgba(180, 200, 240, 0.65)',
      '--text-muted':   'rgba(120, 150, 200, 0.45)',
      '--accent':       '#4488ff',
      '--accent-glow':  'rgba(68, 136, 255, 0.25)',
      '--gold':         '#c9a227',
      '--shadow':       '0 8px 32px rgba(0, 0, 30, 0.6)',
      '--shadow-lg':    '0 16px 64px rgba(0, 0, 30, 0.8)',
    },
  },
  light: {
    id: 'light', label: 'Jour', icon: '☀️',
    vars: {
      '--bg':           '#050810',
      '--surface':      'rgba(255, 255, 255, 0.12)',
      '--surface-2':    'rgba(255, 255, 255, 0.18)',
      '--border':       'rgba(255, 255, 255, 0.25)',
      '--border-bright':'rgba(255, 255, 255, 0.5)',
      '--text-primary': '#ffffff',
      '--text-secondary':'rgba(220, 235, 255, 0.85)',
      '--text-muted':   'rgba(180, 210, 255, 0.55)',
      '--accent':       '#88ccff',
      '--accent-glow':  'rgba(136, 204, 255, 0.3)',
      '--gold':         '#ffe080',
      '--shadow':       '0 8px 32px rgba(0, 0, 30, 0.6)',
      '--shadow-lg':    '0 16px 64px rgba(0, 0, 30, 0.8)',
    },
  },
  sepia: {
    id: 'sepia', label: 'Parchemin', icon: '📜',
    vars: {
      '--bg':           '#1a1208',
      '--surface':      'rgba(35, 24, 10, 0.95)',
      '--surface-2':    'rgba(45, 32, 14, 0.97)',
      '--border':       'rgba(180, 130, 60, 0.2)',
      '--border-bright':'rgba(200, 160, 80, 0.5)',
      '--text-primary': '#f0e0c0',
      '--text-secondary':'rgba(220, 190, 140, 0.7)',
      '--text-muted':   'rgba(180, 150, 100, 0.5)',
      '--accent':       '#c9820a',
      '--accent-glow':  'rgba(201, 130, 10, 0.25)',
      '--gold':         '#e8b830',
      '--shadow':       '0 8px 32px rgba(10, 5, 0, 0.6)',
      '--shadow-lg':    '0 16px 64px rgba(10, 5, 0, 0.8)',
    },
  },
};

function applyTheme(theme) {
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  document.body.style.background = theme.vars['--bg'];
}

export function ThemeSelector() {
  const [theme, setTheme] = useState(() => localStorage.getItem('kairos_theme') || 'dark');
  const [open,  setOpen]  = useState(false);
  const ref = useRef(null);

  useEffect(() => { applyTheme(THEMES[theme]); }, [theme]);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const switchTheme = (id) => {
    setTheme(id);
    localStorage.setItem('kairos_theme', id);
    setOpen(false);
  };

  const cur = THEMES[theme];

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button className="action-btn" onClick={() => setOpen(p => !p)} title="Thème">
        <span>{cur.icon}</span>
        <span className="action-label">{cur.label}</span>
      </button>

      {open && (
        <div className="theme-dropdown">
          {Object.values(THEMES).map(t => (
            <button key={t.id}
              className={`theme-option ${theme === t.id ? 'active' : ''}`}
              onClick={() => switchTheme(t.id)}
            >
              <span className="theme-opt-icon">{t.icon}</span>
              <span className="theme-opt-label">{t.label}</span>
              {theme === t.id && <span className="theme-check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
